import { RecipientFieldEnum } from 'owa-addins-core';
import showBccWell from 'owa-mail-compose-store/lib/actions/showBccWell';
import showCcWell from 'owa-mail-compose-store/lib/actions/showCcWell';
import switchToReadWriteRecipient from 'owa-mail-compose-store/lib/actions/switchToReadWriteRecipient';
import getRecipientsFromWellViewState from 'owa-mail-compose-store/lib/utils/getRecipientsFromWellViewState';
import addReadWriteRecipient from 'owa-readwrite-recipient-well/lib/actions/addReadWriteRecipient';
import clearRecipientWell from 'owa-readwrite-recipient-well/lib/actions/clearRecipientWell';
import showHideFindResult from 'owa-readwrite-recipient-well/lib/actions/showHideFindResult';
export var getRecipients = function (viewState) { return function (type) {
    var recipientWell = getRecipientWellByType(viewState, type);
    return getRecipientsFromWellViewState(recipientWell);
}; };
export var setRecipients = function (viewState) { return function (type, newRecipients) {
    showReadWriteRecipientWell(viewState, type);
    var recipientWell = getRecipientWellByType(viewState, type);
    clearRecipientWell(recipientWell);
    newRecipients.forEach(function (recipient) {
        return addReadWriteRecipient(recipientWell, true /* recipient isValid */, {
            EmailAddress: recipient,
        }).then(function () {
            showHideFindResult(recipientWell, false);
        });
    });
}; };
export var addRecipients = function (viewState) { return function (type, newRecipients) {
    showReadWriteRecipientWell(viewState, type);
    var recipientWell = getRecipientWellByType(viewState, type);
    newRecipients.forEach(function (recipient) {
        return addReadWriteRecipient(recipientWell, true /* recipient isValid */, {
            EmailAddress: recipient,
        }).then(function () {
            showHideFindResult(recipientWell, false);
        });
    });
}; };
function showReadWriteRecipientWell(viewState, type) {
    if (viewState.showCompactRecipientWell) {
        switchToReadWriteRecipient(viewState);
    }
    switch (type) {
        case RecipientFieldEnum.To:
            return;
        case RecipientFieldEnum.Cc:
            showCcWell(viewState);
            return;
        case RecipientFieldEnum.Bcc:
            showBccWell(viewState);
            return;
    }
}
var getRecipientWellByType = function (viewState, type) {
    var recipientWell;
    switch (type) {
        case RecipientFieldEnum.To:
            recipientWell = viewState.toRecipientWell;
            break;
        case RecipientFieldEnum.Cc:
            recipientWell = viewState.ccRecipientWell;
            break;
        case RecipientFieldEnum.Bcc:
            recipientWell = viewState.bccRecipientWell;
            break;
    }
    return recipientWell;
};
//# sourceMappingURL=RecipientsAdapter.js.map